<template>
    <div :key="forceReload">
        <!--Header Components-->
        <base-header class="pb-6" type="">
          <b-row class="align-items-center py-4">
            <b-col lg="12" cols="12">
              <h6 class="h2 d-inline-block mb-0">
                {{language_terms[$route.name]}}
                {{this.$route.meta.type}} Reports
              </h6>
            </b-col>
          </b-row>
        </base-header>
        <b-container fluid class="mt--6">
          <div>
              <loading :active ="progressCounter > 0" 
                color= '#007bff'
                :width= '128'
                :height= '128'
                loader='dots'
                :can-cancel="true" 
                :is-full-page="fullPage">
              </loading>
          </div>

          <b-row>
            <b-col lg="12">
                <div class="row">
                    <div class="col-md-3 mb-1" v-for="(report) in reports" :key="report.id">
                        <div class="card h-60">
                            <div class="card-body" style="text-align:center">
                            <h3 class="card-title">{{report.title}}</h3>
                            <button v-on:click="openReport(report.url)" class="btn btn-primary">Open</button>
                            </div>
                        </div>
                    </div>
                </div>                
            </b-col>
          </b-row>
        </b-container>
    </div>
  </template>
  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
  <style>
  th.VueTables__sortable {
      color:rgb(255,255,255);
  }
  td.VueTables__row  {
      color:black
  }
  .v-data-table /deep/ .sticky-header {
    position: sticky;
    top: var(--toolbarHeight);
  }
  
  .v-data-table /deep/ .v-data-table__wrapper {
    overflow: unset;
  }
  </style>
  <script>
  import "flatpickr/dist/flatpickr.css";
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';  
  import { mapState } from "vuex";
  import axios from "axios";
  import { apiRoutes } from "../../apiRoutes";
  import { authHeader } from "../../global";
  
  export default {
    components:{
      Loading,
    },
    computed: {
      ...mapState({
          language_terms: (state) => state.languages.language_terms,
          selected_lang: (state) => state.languages.selected_langauge,
      })
    },  
    async mounted()
    {
      this.progressCounter++;
        
      //send the prodcategoryid to the backend api to return product list within categories
      let payload = {'type':this.$route.meta.type};
      await axios.post(apiRoutes['REPORTS_RETRIEVE_REPORTS'],payload, authHeader()).then((response)=>
      {
        if (response.data.code==1)
        {
          this.reports = response.data.data;
        }
        else
        {
          this.reports = [];
        }

        this.progressCounter--;
      })
      .catch((error)=> {
        if(error.response)
        {
          console.log(error.response);
          Vue.notify({
            group: "notify",
            type: "error",
            text: error.response.data.msg,
            max: 5,
            duration: 5000,
            speed: 300,
        });
        }else {
          console.log("Problem generate product within categories", error);
        }
      });
    },
    data(){
      return{
        forceReload: 1,
        progressCounter:0,
        fullPage:true,
        reports:[
            {
                "id": 1,
                "title": "",
                "url": "",
            }
        ],
    }
    },
  
    methods:{
        reload() {
          this.forceReload += 1
        },      
        openReport(path)
        {
            window.open(path + '/' + localStorage.access_token)            
        },
    }
  }
  </script>
  